import { FlowStateTicketBooked } from './QuickCheckoutTypes';
import { TicketPlusTicketBooked } from '../../common/components/ticketplus/TicketPlusTicketBooked';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import styled from '@emotion/styled';
import { Colors } from 'dg-web-shared/ui/vars';
import { useNavigate } from 'react-router';
import { Typo } from 'dg-web-shared/ui/typo.ts';

const ReceiptDownloadLink = styled.a({
    display: 'block',
    textDecoration: 'underline',
    color: Colors.white,
    ...Typo.body,
    marginTop: 20,
});

export function QuickCheckoutFlowTicketBooked({
    flowState,
}: {
    flowState: FlowStateTicketBooked;
}) {
    const { ticketWithState, zoneInfo } = flowState;
    const navigate = useNavigate();
    return (
        <TicketPlusTicketBooked
            {...ticketWithState}
            zone={zoneInfo.name}
            city={zoneInfo.city}
            operator={zoneInfo.operatorName}
            onOpenZoneInfo={() => navigate('parking-details')}
            additionalContent={
                <ReceiptDownloadLink
                    href={`/ui-api/quickcheckout/receipt/pdf/${ticketWithState.ticket.ticketId}`}
                    target="_blank"
                    className=""
                >
                    <Localized
                        de="Quittung herunterladen"
                        fr="Télécharger le reçu"
                        it="Scarica la ricevuta"
                        en="Download receipt"
                    />
                </ReceiptDownloadLink>
            }
        />
    );
}
